import React from 'react';
import { useNavigate, Routes, Route } from 'react-router-dom';
import DonorList from './DonorList';
import DonorDetails from './DonorDetails';
import DonorForm from './DonorForm';
import './AdminDonors.css';

const AdminDonors = () => {
  const navigate = useNavigate();
  
  // Function to handle adding a new donor
  const handleAddDonor = () => {
    navigate('/admin/dashboard/donors/form');
  };

  return (
    <div className="admin-donors-container">
      <div className="admin-donors-header">
        <h1>Donor Management</h1>
        <button 
          className="add-donor-btn"
          onClick={handleAddDonor}
        >
          Add New Donor
        </button>
      </div>
      
      {/* Routes for donor management */}
      <Routes>
        <Route index element={<DonorList />} />
        <Route path="details/:id" element={<DonorDetails />} />
        <Route path="form" element={<DonorForm />} />
        <Route path="form/:id" element={<DonorForm />} />
      </Routes>
    </div>
  );
};

export default AdminDonors;